import React, { FC } from 'react';
import './TrashButton.css';
import { FaEye, FaTrashRestoreAlt } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface TrashButtonProps {
	onClick: () => void;
	isLoading?: boolean;
	isActive? : boolean
}

const TrashButton: FC<TrashButtonProps> = ({ 
	onClick, 
	isLoading, 
	isActive
}) => (
	<ActionButton
		classNames="TrashButton"
		icon={isActive ? <FaTrashRestoreAlt/> : <FaEye/>}
		label={isActive ? 'Corbeille' : 'Actifs'}
		onClick={onClick}
		isLoading={isLoading}
		tooltip={isActive ? 'Afficher les élément supprimés' : 'Afficher les éléments actifs'}
		showLabel
	/>
);

export  default TrashButton;
